import { gql } from '@apollo/client';

const TableData = gql`
  fragment TableData on TableData {
    staticData {
      ante
      brandMask
      chatLang
      cap
      clubId
      countryRestrictionInverted
      currency
      defaultBuyIn
      filter
      game
      hiBet
      icon
      isHiLo
      isOneOnOne
      isPlayMoney
      isTableStarter
      loBet
      maxBuyIn
      maxPlayers
      minChipsLimit
      name
      poolBlockMinHands
      tableStakes {
        stakes
        bringIns
        blinds
        antes
      }
      visibilityMaskEx
      variableAntes
      visibilityMask
      tableTypeId
      tableInstanceFlags
      tableId
      tableFlags2
      tableFlags
      structure
      specialName
      serverObject
      server
      seatFinderId
      scalePm
      restrictedCountries
    }
    dynamicData {
      numPlayers
    }
  }
`;

const ZoomDataStruct = gql`
  fragment ZoomDataStruct on ZoomDataStruct {
    dynamicData {
      avgPlayers
      avgPotSize
      avgStackSize
      avgVpip
      earlyBirdMins
      earlyBirdMultipliers {
        licenseId
        multiplier
      }
      licenseEarlyBirdMultiplier
      handsPerHour
      numPlayers
      publProp
    }
    lastEntry
    staticData {
      ante
      blitzFlags
      brandMask
      cap
      chatLang
      countryRestrictionInverted
      currency
      defaultBuyIn
      game
      hiBet
      id
      isHiLo
      isMorphLobby
      isOneOnOne
      isPlayMoney
      loBet
      maxBuyIn
      maxPlayersPerTable
      minChipsLimit
      name
      replayerInstance
      quickLobbyVisible
      restrictedCountries
      scalePm
      server
      serverObj
      specialName
      structure
      tableFlags
      tableFlags2
      tableStakes {
        blinds
        antes
        bringIns
        stakes
      }
      visibilityMask
      visibilityMaskEx
    }
  }
`;

const TournDataStruct = gql`
  fragment TournDataStruct on TournDataStruct {
    dynamicData {
      dummy1
      entrants
      fakeStatus
      goldenSnGEligibleStub
      goldenSnGMilestoneAwardStub
      goldenSnGTotalAddonStub
      happyHoursMultipliers
      mixTournSatellite
      prizePoolMoneyToPublish
      prizePoolMoneyToPublish64
      prizePoolToPublish
      prizePoolToPublish64
      prizePoolUnit
      publProp
      timedTournPlayersThreshold
    }
    entryIds
    lastEntry
    staticData {
      activeFlags
      admissionId
      admissionPrice
      admissions
      awardScheme
      brandAccessMask
      buyIn
      chatLang
      clubId
      countryRestrictionInverted
      currency
      customSpeedDisplayName
      dayTwoStart
      dayTwoStartSec
      doNotAllowToUnreg
      dummy1
      favReference
      fppBuyIn
      game
      guaranteedPrizePool
      hasDayTwoStart
      hasSatellite
      isFlightTourn
      internalReference
      isPlayMoney
      isHiLo
      isPwdProtected
      isRestricted
      knockout
      liveEventMask
      maxPayoutSag
      maxPerTable
      maxPlayers
      minPlayers
      nStackInfo {
        forceReloadAllStacksInLevel
        forceReloadAllStacksInMinutes
        initialStacks
        reloadStacksOnlyWhenEmpty
        unitStackChips
      }
      mobileName
      name
      nameSnG
      numReentries
      pokerNgGroup
      pppId
      progressiveKnockout
      rake
      regEndAbs
      regEndAbsInt
      restrictedCountries
      rmPmLobby
      satelliteTarget
      satelliteTarget64
      satelliteTargetName
      satelliteTargetNameMtt
      satelliteTargetReference
      satelliteTargetReferenceLock
      scalePm
      server
      serverObj
      shortText
      sngScriptId
      speedDisplay
      startDelayMinutes
      step
      structure
      targetServer
      targetWhenStart
      timedTournPlayersPercent
      timedTournPayout
      timedTournTime
      timedTournType
      tournBrand
      tournFlags
      tournFlags2
      tournFlagsServInt
      tournGroup
      tournGroupNameStr
      tournGroupRef
      tournMask
      tournMask2
      tournMask3
      tournMask4
      tournSites
      tournMask6
      tournMask5
      tournSitesEx
      tournamentId
      whenStart
      whenStartInt
    }
    userHasTicket
  }
`;

const TournInvite = gql`
  fragment TournInvite on TournInvite {
    clubId
    isRestarted
    obsolete1
    obsolete2
    pppEntryId
    pppId
    server
    sngScriptId
    tableTrait
    tournFlags
    tournMsg
    tournToRematchId
    tournamentId
  }
`;

export const ActiveGamesUpdate = gql`
  subscription ActiveGamesUpdate {
    activeGames {
      joined
      tables {
        ...TableData
      }
      zoomTypes {
        ...ZoomDataStruct
      }
      tournaments {
        ...TournDataStruct
      }
      tournInvite {
        ...TournInvite
      }
    }
  }
  ${TableData}
  ${ZoomDataStruct}
  ${TournDataStruct}
  ${TournInvite}
`;

export const ActiveGames = gql`
  query ActiveGames {
    activeGames {
      tables {
        ...TableData
      }
      joined
      tournaments {
        ...TournDataStruct
      }
      zoomTypes {
        ...ZoomDataStruct
      }
      tournInvite {
        ...TournInvite
      }
    }
  }

  ${TableData}
  ${ZoomDataStruct}
  ${TournDataStruct}
  ${TournInvite}
`;
